import {Component, Input, OnInit} from '@angular/core';
import {EnvironmentService} from '../../../services/environment.service';
import {BaseTileComponent} from '../tile.component';
import {ScormCloudService} from '../../../services/scorm-cloud.service';
import {ProfileService} from '../../profile/profile.service';

@Component({
  selector: 'itpx-scorm-cloud-tile',
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.css']
})

export class ScormCloudTileComponent extends BaseTileComponent implements OnInit {
  @Input() deliverable: any;

  private images: string;
  private href: string = '#';
  @Input() profile: any;

  constructor(
    private environmentService: EnvironmentService,
    private scormCloudService: ScormCloudService,
  ) {
    super();
  }

  ngOnInit() {
    this.images = this.environmentService.config['server'].images;
    super.initScormCloud(this.scormCloudService, this.profile, this.deliverable, true);
  }

  complete(deliverable: any, createTarget: boolean) {
    if (!deliverable.disabled)
      this.href = '/#/app/' + deliverable.type + '/' + deliverable.id;
    super.complete(deliverable, createTarget);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/content/scormcloud/tile.component.ts